(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
customElements.whenDefined('details-disclosure').then(() => {
class FooterMenu extends DetailsDisclosure {
constructor() {
super();
this.reset(false);
window.addEventListener('on:breakpoint-change', this.reset.bind(this));
}

reset() {
const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
const isConfirmNewsletter = !isLargeScreen &&
(window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

this.disclosure.open = isLargeScreen || isConfirmNewsletter;

if (isLargeScreen) {
this.toggle.setAttribute('tabindex', '-1');
} else {
this.toggle.removeAttribute('tabindex');
}
}
}

customElements.define('footer-menu', FooterMenu);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okreator-voting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.okv:not([data-ready])');
    roots.forEach((root) => {
      root.dataset.ready = 'true';
      const endpoint = root.dataset.endpoint.replace(/\/$/, '');
      const campaign = root.dataset.campaign;
      const maxVotes = Number(root.dataset.maxVotes || 1);
      const customerLoggedIn = root.dataset.customerLoggedIn === 'true';
      const startAt = Date.parse(root.dataset.start || '');
      const endAt = Date.parse(root.dataset.end || '');
      const notice = root.querySelector('[data-notice]');
      const cards = [...root.querySelectorAll('[data-entry]')];
      let votesUsed = 0;

      const message = (value) => {
        notice.textContent = value;
        notice.classList.toggle('is-visible', Boolean(value));
      };

      const periodState = () => {
        const now = Date.now();
        if (!Number.isNaN(startAt) && now < startAt) return 'upcoming';
        if (!Number.isNaN(endAt) && now > endAt) return 'ended';
        return 'active';
      };

      const syncButtons = () => {
        const disabled = !customerLoggedIn || periodState() !== 'active' || !endpoint || votesUsed >= maxVotes;
        root.querySelectorAll('[data-vote],[data-dialog-vote]').forEach((button) => {
          button.disabled = disabled;
        });
      };

      const updateCountdown = () => {
        const target = periodState() === 'upcoming' ? startAt : endAt;
        const distance = Number.isNaN(target) ? 0 : Math.max(0, target - Date.now());
        const values = {
          days: Math.floor(distance / 86400000),
          hours: Math.floor(distance / 3600000) % 24,
          minutes: Math.floor(distance / 60000) % 60,
          seconds: Math.floor(distance / 1000) % 60
        };
        Object.entries(values).forEach(([key, value]) => {
          const node = root.querySelector(`[data-${key}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        syncButtons();
      };

      const applyStatus = (data) => {
        votesUsed = Number(data.votesUsed || 0);
        cards.forEach((card) => {
          const count = data.counts && data.counts[card.dataset.entryId];
          const countNode = card.querySelector('[data-count]');
          if (countNode && count !== undefined) {
            countNode.textContent = count;
            countNode.hidden = false;
          }
        });
        syncButtons();
      };

      if (!customerLoggedIn) {
        syncButtons();
      } else if (endpoint) {
        fetch(`${endpoint}/status?campaign=${encodeURIComponent(campaign)}`, { credentials: 'same-origin' })
          .then((response) => response.ok ? response.json() : Promise.reject())
          .then(applyStatus)
          .catch(() => message('Voting data is temporarily unavailable. Please try again later.'));
      } else {
        message('Voting preview: connect the secure voting endpoint in theme settings before launch.');
      }

      const submitVote = async (card) => {
        if (!customerLoggedIn || !endpoint || periodState() !== 'active' || votesUsed >= maxVotes) return;
        const buttons = card.querySelectorAll('[data-vote],[data-dialog-vote]');
        buttons.forEach((button) => { button.disabled = true; });
        try {
          const response = await fetch(`${endpoint}/vote`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ campaign, entryId: card.dataset.entryId })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.message || 'Vote could not be recorded.');
          applyStatus(data);
          message(data.message || 'Your vote has been recorded.');
        } catch (error) {
          message(error.message || 'Vote could not be recorded. Please try again.');
          syncButtons();
        }
      };

      cards.forEach((card) => {
        const dialog = card.querySelector('[data-dialog]');
        card.querySelector('[data-details]')?.addEventListener('click', () => dialog.showModal());
        card.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        card.querySelector('[data-vote]')?.addEventListener('click', () => submitVote(card));
        card.querySelector('[data-dialog-vote]')?.addEventListener('click', () => submitVote(card));
      });

      root.querySelector('[data-load-more]')?.addEventListener('click', (event) => {
        const hidden = cards.filter((card) => card.classList.contains('is-hidden'));
        hidden.slice(0, Number(root.dataset.loadCount || 5)).forEach((card) => card.classList.remove('is-hidden'));
        if (hidden.length <= Number(root.dataset.loadCount || 5)) event.currentTarget.hidden = true;
      });

      root.querySelector('[data-search]')?.addEventListener('input', (event) => {
        const term = event.target.value.trim().toLowerCase();
        cards.forEach((card) => {
          card.classList.toggle('is-hidden', Boolean(term) && !card.dataset.searchText.includes(term));
        });
      });

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r1-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('r1-newsletter-popup')) {
    class R1NewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.sessionKey = 'oknife-r1-popup-dismissed';
        this.subscriberKey = 'oknife-r1-newsletter-subscribed';
        this.success = Boolean(this.querySelector('[data-r1-popup-success]'));
        this.designMode = this.dataset.designMode === 'true';

        this.querySelectorAll('[data-r1-popup-close]').forEach((button) => {
          button.addEventListener('click', () => this.dismiss());
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dismiss();
        });

        if (this.success) {
          localStorage.setItem(this.subscriberKey, 'true');
          this.open();
          return;
        }

        if (this.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          });
        }

        if (localStorage.getItem(this.subscriberKey) === 'true') return;
        if (sessionStorage.getItem(this.sessionKey) === 'true') return;

        const delay = Number(this.dataset.delay) || 5000;
        this.timer = window.setTimeout(() => this.open(), delay);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.body.classList.add('r1-newsletter-popup-open');
      }

      dismiss() {
        sessionStorage.setItem(this.sessionKey, 'true');
        this.dialog.close();
        document.body.classList.remove('r1-newsletter-popup-open');
      }
    }

    customElements.define('r1-newsletter-popup', R1NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
